module.exports = __webpack_public_path__ + "img/logo.d69d61bf.svg";